<template>
	<div class="select-member-list-row" @click="onChange">
		<div class="select-member-list-row-content d-flex pa-2">	
			<div style="width: 100%;">
				<div class="name">{{ this.item.name }}</div>
				<div class="tel">連絡先: {{ this.item.tel }}</div>
				<GBClasses
					:items="this.item.classes"
					:max_width=278
					:all_show=true
				/>
			</div>
			<div class="member-list-row-select">
				<v-icon class="alert-icon" v-if="alert">error</v-icon>
				<v-avatar v-if="selected" color="orange" size="32">
					<v-icon color="white">done</v-icon>
				</v-avatar>
				<v-avatar v-else size="31" class="no-selected"></v-avatar>
			</div>
		</div>
	</div>
</template>
<script>
import GBClasses from './GBClasses';
export default {
	name: 'GBSelectMemberListRow',
	props: [
		"item",
		"alert",
		"selectedMember",
	],
	components: {
		GBClasses,
	},
	methods: {
		onChange: function() {
			this.$emit("change-select-member", {
				item: this.item,
				select: !this.selected,
			});
		},
	},
	computed: {
		selected: function() {
			if (!this.selectedMember)
				return;
			return this.selectedMember.some((m) => {
				return m.code === this.item.code;
			});
		},
	},
};
</script>
<style>
	.select-member-list-row {
		position: relative;
		flex: 1 1 auto;
		overflow: hidden;
		width: 100%;
		background-color: #fefefe;
		border-bottom: solid 1px #a9a9a9;
		cursor: pointer;
		user-select: none;
	}
	.select-member-list-row:hover {
		background-color: #eee;
	}
	.select-member-list-row-content {
		padding-right: 14px !important;
	}
	.select-member-list-row-content .name{
		max-width: 290px;
		word-wrap: break-word;
	}
	.member-list-row-select {
		display: flex;
		align-items: center;
	}
	.no-selected {
		border: solid 1px orange;
		border-radius: 50%;
		background-color: #EEEEEE;
	}
</style>
<style scoped>
	.alert-icon {
		position: absolute;
		right: 18px;
		top: 0;
		opacity: .6;
		cursor: pointer;
		pointer-events: none;
		color: darkorange;
	}
</style>
